/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".filter-input-box[_ngcontent-%COMP%]{margin-right:8px;padding:0 10px;height:35px}\n/*# sourceMappingURL=limit-store-list.component.css.map*/"];
export { styles as styles };
